import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20golden%20gradient%20background%20with%20soft%20flowing%20curves%2C%20minimal%20geometric%20overlay%2C%20elegant%20professional%20composition%2C%20warm%20amber%20tones%2C%20subtle%20texture%2C%20no%20text%2C%20no%20people%2C%20clean%20aesthetic&width=1600&height=600&seq=cta-bg-home-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70"></div>

      <div className="relative z-10 w-full max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
          {t('home.cta.title')}
        </h2>
        <p className="text-sm md:text-base text-background-50/80 mb-8 max-w-xl mx-auto leading-relaxed">
          {t('home.cta.subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <button
            onClick={() => {
              if (typeof window !== 'undefined' && window.navigator) {
                const dummy = document.createElement('textarea');
                document.body.appendChild(dummy);
                dummy.value = window.location.href;
                dummy.select();
                document.execCommand('copy');
                document.body.removeChild(dummy);
                alert('链接已复制！请使用 Ctrl+D (Windows) 或 Cmd+D (Mac) 添加到书签。');
              }
            }}
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-bookmark-line"></i>
            </div>
            {t('home.cta.button')}
          </button>
          <Link
            to="/category/usage-tutorial"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/10 backdrop-blur-sm text-background-50 font-medium rounded-md border border-background-50/25 hover:bg-background-50/20 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-guide-line"></i>
            </div>
            {t('home.cta.secondary')}
          </Link>
        </div>
      </div>
    </section>
  );
}